import { CapoPlugin } from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];